import { gql, useMutation } from '@apollo/client';
import { DateTime } from 'luxon';
import { useCallback } from 'react';

import { Position } from '@work4all/models/lib/Classes/Position.entity';

import { PositionDoneFormData } from './components/PositionDoneDialog';

const POSITION_DONE_GQL = gql`
  mutation FertigmeldungToPosition(
    $positionCode: Int!
    $userCode: Int!
    $completionNote: String!
    $completionDate: DateTime!
    $isDone: Boolean!
  ) {
    fertigmeldungToPosition(
      positionenCode: $positionCode
      benutzerCode: $userCode
      fertigmeldungNote: $completionNote
      fertigmeldungDate: $completionDate
      fertigmeldung: $isDone
    ) {
      id: code
      fertigmeldungDatum
    }
  }
`;

type PositionDoneArgs = {
  positionCode: number;
  userCode: number;
  completionNote: string;
  completionDate: string;
  isDone: boolean;
};

export const usePositionDoneMutation = () => {
  const [positionDoneMutation] = useMutation<
    { fertigmeldungToPosition: Position },
    PositionDoneArgs
  >(POSITION_DONE_GQL);

  return useCallback(
    (formData: PositionDoneFormData) => {
      if (!formData.position || !formData.user) {
        throw new Error('Position and user are required');
      }

      const date = DateTime.fromISO(formData.completionDate);
      positionDoneMutation({
        variables: {
          positionCode: formData.position.id,
          userCode: formData.user.id,
          completionNote: formData.notes,
          completionDate: DateTime.utc(date.year, date.month, date.day).toISO(),
          isDone: formData.toRemoveDone ? false : true,
        },
      });
    },
    [positionDoneMutation]
  );
};
